export const currencyConfig = {
    defaultCurrency: 'eur',
    supportedCurrencies: [
        { code: 'eur', label: 'EUR' },
        { code: 'gbp', label: 'GBP' },
        { code: 'usd', label: 'USD' },
    ],
};
